"use client";

import { useAuth } from "@clerk/nextjs";
import { Loader2, RefreshCcw, Settings2 } from "lucide-react";
import { Button } from "~/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";
import { useProcessVideo } from "~/hooks/useProcessVideo";
import { useVideoControls } from "~/state/videos/hooks/use-video-controls";

export default function AdditionalVideoControls({
  videoId,
}: {
  videoId: number;
}) {
  const { isSignedIn } = useAuth();
  const {
    isMiniPlayerHidden,
    toggleIsMiniPlayerHidden,
    isAutoPauseEnabled,
    toggleIsAutoPauseEnabled,
  } = useVideoControls();

  const { isRunning, processVideo } = useProcessVideo(videoId);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <Settings2 size={17} />
          <span className="sr-only">Settings</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Video Controls</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuCheckboxItem
            checked={isMiniPlayerHidden}
            onCheckedChange={() => void toggleIsMiniPlayerHidden()}
          >
            Hide Mini Player
          </DropdownMenuCheckboxItem>
          <DropdownMenuCheckboxItem
            checked={isAutoPauseEnabled}
            onCheckedChange={toggleIsAutoPauseEnabled}
          >
            Auto Pause
          </DropdownMenuCheckboxItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onSelect={processVideo}
          disabled={isRunning || !isSignedIn}
        >
          {isRunning ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <RefreshCcw className="h-4 w-4 text-muted-foreground" />
          )}
          Refresh Transcripts
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
